import { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function Thread({ issue, endpoint, me, placeholder, onSent, hint }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const msgs = issue.messages || [];
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post(endpoint, { text }); setText(""); toast.success(data.reopened ? "Reply sent — your report has been reopened" : data.emailed === undefined ? "Reply sent" : data.emailed ? "Reply sent · author emailed" : "Reply sent · email could not be sent"); onSent(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="mt-3 space-y-2" data-testid={`thread-${issue.id}`}>
      {msgs.map((m) => (
        <div key={m.id} className={`rounded-md px-3 py-2 text-xs max-w-[85%] ${m.from === me ? "ml-auto bg-amber-600/15 border border-amber-500/30" : "bg-slate-900 border border-slate-800"}`} data-testid={`thread-msg-${m.id}`}>
          <p className="text-[10px] text-slate-500 mb-1">{m.from === "owner" ? "Studio" : "Author"} · {fmtDate(m.at)}</p>
          <p className="text-slate-200 whitespace-pre-wrap">{m.text}</p>
        </div>
      ))}
      <div className="flex gap-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder={placeholder} maxLength={2000} className="h-9 text-sm" data-testid={`thread-input-${issue.id}`} />
        <Button size="sm" variant="outline" className="border-amber-500/40 h-9" disabled={busy || text.trim().length < 2} onClick={send} data-testid={`thread-send-${issue.id}`}><Send size={13} className="mr-1" />Reply</Button>
      </div>
      {hint && <p className="text-[11px] text-slate-500">{hint}</p>}
    </div>
  );
}
